module.exports = __webpack_public_path__ + "static/assets/b252cde29d665dedfe60d103f92c597c.gif";